import {
  Box,
  Dialog,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { APIProvider } from "@vis.gl/react-google-maps";
import { BentoCategoriesContext } from "contexts/BentoCategories";
import { NewCampaignContext } from "contexts/NewCampaign";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { API_KEY } from "components/LocationAutocomplete/useAutoCompletePrediction";
import { navigateBack } from "utils/navigation";

import CampaignDetails from "../CampaignDetails/EditableCampaignDetails";
import BrandSearch from "./BrandSearch";
import EditTitle from "./EditTitle";
import PreviewCampaign from "./PreviewCampaign";
import SelectCampaignType from "./SelectCampaignType";
import SelectCollection from "./SelectCollection";

export default function NewCampaign() {
  const theme = useTheme();
  const { topLevelCategories, fetchBentoCategories } = useContext(
    BentoCategoriesContext,
  );
  const { campaignTitle, setCampaignTitle } = useContext(NewCampaignContext);
  const { currentOrg } = useContext(OrganizationUserContext);
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (topLevelCategories.length === 0) {
      fetchBentoCategories();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  const handleClose = () => {
    navigateBack(navigate, location.pathname, 2);
  };

  return (
    <Dialog
      open={true}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      fullScreen={isMobileScreen}
      PaperProps={{
        sx: !location.pathname.includes("type")
          ? {
              height: { md: "100%" },
            }
          : {},
      }}
    >
      <IconButton
        sx={{
          fontSize: 14,
          position: "absolute",
          right: 5,
          top: 5,
        }}
        onClick={handleClose}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      <EditTitle
        campaignTitle={campaignTitle}
        setCampaignTitle={setCampaignTitle}
      />

      <Routes>
        <Route path="type" element={<SelectCampaignType />} />

        <Route
          path="search"
          element={
            <APIProvider apiKey={API_KEY || ""}>
              <BrandSearch />
            </APIProvider>
          }
        />
        <Route
          path="repitch"
          element={
            <APIProvider apiKey={API_KEY || ""}>
              <BrandSearch repitching />
            </APIProvider>
          }
        />
        <Route path="collection" element={<SelectCollection />} />
        <Route path="details" element={<CampaignDetails />} />
        <Route path="preview" element={<PreviewCampaign />} />
      </Routes>
    </Dialog>
  );
}
